import React from 'react';
import { observer } from 'mobx-react';
import UserStore from '../store/UserStore';
import Rating from './RatingPage';

const HomePage: React.FC = observer(() => {
  return <Rating />;
});

export default HomePage;